import type { AriaRole, ReactNode } from 'react'

type Props = {
  children: ReactNode
  role?: AriaRole
  'aria-label'?: string
  'aria-live'?: 'polite' | 'assertive' | 'off'
  className?: string
}

/**
 * 页面级异步占位外壳：占满主列并垂直居中（加载失败、空列表、无权访问等共用）。
 */
export function PageCenteredPlaceholder({
  children,
  role,
  'aria-label': ariaLabel,
  'aria-live': ariaLive,
  className,
}: Props) {
  return (
    <div
      role={role}
      aria-label={ariaLabel}
      aria-live={ariaLive}
      className={[
        'flex min-h-0 w-full flex-1 flex-col items-center justify-center px-4 py-16 text-center sm:px-6 sm:py-20',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="flex w-full max-w-md flex-col items-center gap-4 sm:max-w-lg sm:gap-5">
        {children}
      </div>
    </div>
  )
}
